export const buttonAppearances = ['flat', 'glossy', 'verticalGradient', 'horizontalGradient', 'diagonalGradient'];
